export { CookieBanner } from './CookieBanner.component';
